<template>
  <div>
    <v-stepper v-model="pageIndex" vertical>
      <!-- USER DATA -->
      <v-stepper-step :complete="pageIndex > 1" step="1">
        Dati Utente
      </v-stepper-step>

      <v-stepper-content step="1">
        <div>
          <StepEmailUsername
            v-bind:userData="this.newPassInfo.UserData"
          ></StepEmailUsername>
        </div>
        <v-btn color="primary" @click="generateOTP" v-bind:disabled="disableBtnNextSetEamil"> Avanti </v-btn>
      </v-stepper-content>

      <!-- OTP -->
      <v-stepper-step :complete="pageIndex > 2" step="2">
        One Time Password
      </v-stepper-step>
      <v-stepper-content step="2">
        <div>
          <StepOTP v-bind:userData="this.newPassInfo.UserData"></StepOTP>
        </div>
        <v-btn color="primary" @click="validateOTP" v-bind:disabled="disableBtnNextSetOtp"> Avanti </v-btn>
        <v-btn text @click="pageIndex--"> Indietro </v-btn>
      </v-stepper-content>

      <!-- New Password -->
      <v-stepper-step :complete="pageIndex > 3" step="3" >
        New Password
      </v-stepper-step>

      <v-stepper-content step="3">
        <div>
          <StepNewPassword
            v-bind:userData="this.newPassInfo.UserData"
          ></StepNewPassword>
        </div>
        <v-btn color="primary" @click="changePassword" v-bind:disabled="disableBtnNextSetPassword"> Conferma </v-btn>
      </v-stepper-content>
    </v-stepper>

    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style lang="scss">
</style>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import StepEmailUsername from "./Steps/StepEmailUsername";
import StepOTP from "./Steps/StepOTP";
import StepNewPassword from "./Steps/StepNewPassword";

export default {
  props: ["page", "jwt"],
  components: {
    StepEmailUsername,
    StepOTP,
    StepNewPassword,
  },
  methods: {
    
    generateOTP: function () {
     this.btnNextSetEmail=false;
      EasyPlanClient.User.RecoverPassword(this.newPassInfo.UserData.Username)
        .then((res) => {
          console.debug("generate otp");
          console.debug(res);
         
          this.pageIndex++;
        })
        .catch((error) => {
          this.pageIndex--;

          console.error("si è verificato un errore" + this.error);
          console.error(error);
        }).finally(()=>{
          this.btnNextSetEmail=true;});
    },

    validateOTP: function () {
      this.btnNextSetOtp=false;
      EasyPlanClient.User.ValidateOTPCode(
        this.newPassInfo.UserData.Username,
        this.newPassInfo.UserData.otpCode
      )
        .then((res) => {
          console.debug("validate otp");
          console.debug(res);

          this.pageIndex++;
        })
        .catch((error) => {
          this.pageIndex--;

          console.error("si è verificato un errore" + this.error);
          console.error(error);
        }).finally((e)=>{this.btnNextSetOtp=true;});
    },

    changePassword() {
      this.btnNextSetNewPassword=false;
      EasyPlanClient.User.ChangePassword(
        this.newPassInfo.UserData.Username,
        this.newPassInfo.UserData.otpCode,
        this.newPassInfo.UserData.Password
      )
        .then((res) => {
          console.debug("changing password");
          console.debug(res); 
          this.$emit('close-dialog')
        })
        .catch((error) => {
          this.pageIndex--;
          console.log("nope nope");
          console.error("si è verificato un errore" + this.error);
          console.error(error);
        }).finally(()=>{this.btnNextSetNewPassword=true;});
    },
    
  },
  computed: {
    disableBtnNextSetOtp(){
      return !this.newPassInfo.UserData.otpCode.length>0||!this.btnNextSetOtp;
    },
    disableBtnNextSetEamil(){
      return !this.newPassInfo.UserData.Username.length>0||!this.btnNextSetEmail;
    }, 
    disableBtnNextSetPassword(){
      return (!this.newPassInfo.UserData.Password.length>0 ||
      this.newPassInfo.UserData.RPassword != this.newPassInfo.UserData.Password) && 
      this.btnNextSetNewPassword;
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },

  data() {
    let data = {
      pageIndex: 1,
      error: "",
      btnNextSetEmail:true,
      btnNextSetOtp:true,
      btnNextSetNewPassword:true,
      newPassInfo: {
        UserData: {
          otpCode: "",
          Username: "",
          RPassword: "",
          Password: "",

          HasValidPassword: function () {
            const r1 = /[A-Za-z]{1,}/;
            const r2 = /([0-9]{1,})/;
            return (
              r1.test(String(this.Password)) &&
              r2.test(String(this.Password)) &&
              this.Password.length >= this.MinLenPassword()
            );
          },
          MinLenPassword: function () {
            return 8;
          },
          PasswordConfirmed: function () {
            return this.RPassword == this.Password;
          },
          AreValid() {
            return (
              this.Username !== "" &&
              this.Password !== "" &&
              this.HasValidMail() &&
              this.HasValidPassword() &&
              this.PasswordConfirmed() &&
              this.Password.length >= this.MinLenPassword()
            );
          },
        },
      },
    };
    return data;
  },
};
</script>

